import React from 'react';
import style from 'acscp/components/common/callUsButton.module.scss';
import { ButtonLaunchingPopover } from 'acscp/components/common/buttonLaunchingPopover';
import { CallUsPopover } from 'acscp/components/common/callUsPopover';

interface CallUsButtonProps {
    bodyClass: string;
}

class CallUsPopoverButton extends React.Component<CallUsButtonProps, {}> {
    render(): JSX.Element {
        return (
                <ButtonLaunchingPopover
                    buttonClassName={this.props.bodyClass}
                    childComponentFactory={closePopover => <CallUsPopover closeSelf={closePopover} />}
                    popoverBodyClassName={style.CallUsPopover}
                    popoverPosition={'top'}
                    popoverHorizontalAlignment={'start'}
                >
                    {this.props.children}
                </ButtonLaunchingPopover>
            );
    }
}

export const CallUsButton = CallUsPopoverButton;
